import { render } from "./list_chat_users.vue?vue&type=template&id=7c2dcd86&lang=html"
import script from "./list_chat_users.vue?vue&type=script&lang=js"
export * from "./list_chat_users.vue?vue&type=script&lang=js"

import "./list_chat_users.vue?vue&type=style&index=0&id=7c2dcd86&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__